import React from 'react';
import Styles from './separator.less';

interface SeparatorProps {
    type: string;
}

export default class Separator extends React.Component<SeparatorProps> {
    public render() {
        return (
            <div className={Styles[`third-party-menu-separator-${this.props.type}`]} />
        );
    }
}
